import React, { useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import NothingToShow from "../NothingToShow";
import CustomModal from "../CustomModal";
import IndiretoDetailModal from "../IndiretoDetailModal";

const TabelaPlanejamentoIndiretos = ({ currentTab, edit, indiretos, total, dadosPlanejamento, setDadosPlanejamento, allCustosIndiretos }) => {

    const openModalFunction = (title, item) => {
        CustomModal.show({
            title: title,
            body: (
                <IndiretoDetailModal
                    dadosPlanejamento={dadosPlanejamento}
                    setDadosPlanejamento={setDadosPlanejamento}
                    currentTab={currentTab}
                    item={item}
                    edit={edit}
                    allCustosIndiretos={allCustosIndiretos}
                    onCancel={() => CustomModal.hide()}
                />
            )
        })
    }

    return (
        <>
            <div className="d-flex justify-content-between mb-2">
                <h4>Custos Indiretos</h4>

                {edit &&
                    <Button onClick={() => openModalFunction("Novo Custo Indireto")} disabled={!edit}><FaPlus /></Button>
                }
            </div>

            <Table striped>
                <thead>
                    <tr>
                        <th className="list-header" style={{ width: '7%' }}>Tipo</th>
                        <th className="list-header" style={{ width: '7%' }}>Descrição</th>
                        <th className="list-header" style={{ width: '7%' }}>Valor original</th>
                        <th className="list-header" style={{ width: '7%' }}>Valor total</th>
                        <th className="list-header" style={{ width: '16%' }}>Observações</th>
                    </tr>
                </thead>

                <tbody>
                    {indiretos.length > 0 ? indiretos.map((item, index) => (
                        <tr key={index} className="list-row cursor-pointer-row" onClick={() => openModalFunction(edit ? "Editar Custo Indireto" : "Detalhes Custo Indireto", item)}>
                            <td className="list-row-cell">{item.tipo}</td>
                            <td className="list-row-cell">{item.descricao_custo_indireto}</td>
                            <td className="list-row-cell">
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                }).format(item.valor_original_custo_indireto)}</td>
                            <td className="list-row-cell">{new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(item.valor_custo_indireto)}</td>
                            <td className="list-row-cell">{item.observacao}</td>
                        </tr>
                    )) : 
                    <tr className="list-row">
                        <td className="list-row-cell" colSpan={5}><NothingToShow /></td>
                    </tr>}
                    {(total && total != 0 || indiretos.length != 0) &&
                        <tr className="list-row">
                            <td className="list-row-cell font-weight-bold">Total</td>
                            <td className="list-row-cell font-weight-bold"></td>
                            <td className="list-row-cell font-weight-bold"></td>
                            <td className="list-row-cell font-weight-bold">{new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(total)}</td>
                            <td className="list-row-cell font-weight-bold"></td>
                        </tr>}
                </tbody>
            </Table>
        </>
    )
};

export default TabelaPlanejamentoIndiretos;
